/**
 * @author ASDS Team
 * @description Constains constants for error labels across entire application.
 */
const errorLabels = {
    unknownHandler: 'Handler not defined',
};

export default errorLabels;